import React from 'react';
import styles from './Modal.module.scss';
import closeIcon from './close.png';

class Modal extends React.Component {
  componentDidMount() {
    document.querySelector('body').style.overflow = 'hidden';
  }

  componentWillUnmount() {
    document.querySelector('body').style.overflow = '';
  }
  
  render() {
    return (
      <div
        className={styles.modalBackground}
        style={{display: this.props.showModal ? 'initial' : 'none'}}
        onClick={() => this.props.closeModal()}
      >
        <div
          className={styles.modalContainer}
          onClick={(e) => e.stopPropagation()}
        >
          <div className={styles.header}>
            <h2 className={styles.title}>
              {this.props.title}
            </h2>
            <img
              className={styles.closeIcon}
              src={closeIcon}
              alt='close-icon'
              onClick={() => this.props.closeModal()}
            />
          </div>
          <div className={styles.body}>
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;